/**
 * Atlas layout constants — DOM-free so both the texture painter (main thread)
 * and the greedy mesher (worker) can share them.
 */

export const TILE = 32;
/** Full-tile gutter: the wrapped copies stay >=1 texel wide up to mip 5, so
 *  hardware mipmaps never blend neighbouring tiles (alpha bleed -> speckles). */
export const GUTTER = 32;
export const CELL = TILE + GUTTER * 2;
/** 40 x 40 cells = 1600 tiles in 3840 x 3840 px: both sides stay under the 4096 px
 *  texture limit of older GPUs. */
export const ATLAS_COLS = 40;
export const ATLAS_ROWS = 40;
export const ATLAS_W = ATLAS_COLS * CELL;
export const ATLAS_H = ATLAS_ROWS * CELL;

/** Atlas-space UV of a tile's content origin (top-left of the TILE px area). */
export function tileOriginU(t: number): number {
  return ((t % ATLAS_COLS) * CELL + GUTTER) / ATLAS_W;
}
export function tileOriginV(t: number): number {
  return (((t / ATLAS_COLS) | 0) * CELL + GUTTER) / ATLAS_H;
}
